import { render, staticRenderFns } from "./ValSummary.vue?vue&type=template&id=724cf008&"
import script from "./ValSummary.vue?vue&type=script&lang=ts&"
export * from "./ValSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports